import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { fetchPortfolioAnalysisSummary } from "../../../store/slice/analyserSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import { useNavigate } from "react-router-dom";
import Analysis from "../../ProppertyAnalyser/AnalysisReport/Analysis";

interface ReviewProps {
  onNext: () => void;
  onBack: () => void;
  portfolioTrackerId?: number;
  isEditable?: boolean;
}

const Review = ({ onNext, onBack, portfolioTrackerId, isEditable }: ReviewProps) => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const reload = useSelector((state: RootState) => state.analyser.reload);

  useEffect(() => {
    if (portfolioTrackerId) {
      dispatch(fetchPortfolioAnalysisSummary(portfolioTrackerId.toString()));
    }
  }, [portfolioTrackerId, reload]);

  return (
    <div>
      <Analysis loadFromPortfolioTracker={true} isEditable={isEditable} />
      <div className="flex justify-between mt-4">
        <div>
          {isEditable && (
            <Button
              id="aprev-btn-back"
              data-testid="aprev-btn-back"
              label="Back"
              icon="pi pi-arrow-left"
              onClick={onBack}
              className="p-button-secondary"
            />
          )}
        </div>
        <div>
          <Button
            id="aprev-btn-results"
            data-testid="aprev-btn-results"
            label="Results"
            icon="pi pi-arrow-right"
            iconPos="right"
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Review;
